import { Injectable, signal } from '@angular/core';
import themes from "devextreme/ui/themes";
import { AppstateService } from './appstate.service';

@Injectable({
  providedIn: 'root',
})
export class ThemingService {

  constructor(private appstateService: AppstateService) { 
  }

  toggleTheme() {
    this.appstateService.isDarkMode.set(!this.appstateService.isDarkMode());
    if (this.appstateService.isDarkMode()) {
      themes.current("material.hch.dark");    
    } else {
      themes.current("material.hch.light");    
    }
  }

  setDefaultMode() {
    themes.current("material.hch.light");    
    this.appstateService.isDarkMode.set(false);
  }

  setDarkMode() {
    themes.current("material.hch.dark");    
    this.appstateService.isDarkMode.set(true);
  }

}
